<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Planos de Ações Gerados</h4>
        </div>
        <div class="card-body">
          <table class="table table-striped" datatable [dtOptions]="dtOptions">
            <thead>
              <tr>
                <th>Pergunta</th>
                <th>Data Criação</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let pergunta of perguntas">
                <td>{{ pergunta.titulo }}</td>
                <td>{{ pergunta.dataCriacao | date:'dd/MM/yyyy' }}</td>
                <td>
                  <button class="btn btn-sm btn-primary" (click)="abrirModalPlanoAcao(modalPlanoAcao, null, pergunta)">
                    <i class="feather icon-plus"></i> Criar Plano de Ação
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Plano de Ação -->
<ng-template #modalPlanoAcao>
  <div class="modal-header">
    <h5 class="modal-title">{{ planoSelecionado ? 'Editar' : 'Novo' }} Plano de Ação</h5>
    <button type="button" class="close" (click)="modalService.dismissAll()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="planoAcaoForm">
      <div class="form-group">
        <label>Pergunta que gerou o plano</label>
        <select class="form-control" formControlName="perguntaId">
          <option value="">Selecione uma pergunta</option>
          <option *ngFor="let pergunta of perguntas" [value]="pergunta.id">
            {{ pergunta.descricao }}
          </option>
        </select>
        <div class="invalid-feedback" *ngIf="planoAcaoForm.get('perguntaId').invalid && planoAcaoForm.get('perguntaId').touched">
          Por favor, selecione a pergunta que gerou o plano.
        </div>
      </div>

      <div class="form-group">
        <label>O que será feito?</label>
        <input type="text" class="form-control" formControlName="what">
        <div class="invalid-feedback" *ngIf="planoAcaoForm.get('what').invalid && planoAcaoForm.get('what').touched">
          Por favor, descreva o que será feito.
        </div>
      </div>

      <div class="form-group">
        <label>Por que será feito?</label>
        <textarea class="form-control" formControlName="why" rows="2"></textarea>
        <div class="invalid-feedback" *ngIf="planoAcaoForm.get('why').invalid && planoAcaoForm.get('why').touched">
          Por favor, explique o motivo.
        </div>
      </div>

      <div class="form-group">
        <label>Onde será feito?</label>
        <input type="text" class="form-control" formControlName="where">
        <div class="invalid-feedback" *ngIf="planoAcaoForm.get('where').invalid && planoAcaoForm.get('where').touched">
          Por favor, especifique o local.
        </div>
      </div>

      <div class="form-group">
        <label>Quando será feito?</label>
        <input type="date" class="form-control" formControlName="when">
        <div class="invalid-feedback" *ngIf="planoAcaoForm.get('when').invalid && planoAcaoForm.get('when').touched">
          Por favor, selecione a data.
        </div>
      </div>

      <div class="form-group">
        <label>Quem fará?</label>
        <input type="text" class="form-control" formControlName="who">
        <div class="invalid-feedback" *ngIf="planoAcaoForm.get('who').invalid && planoAcaoForm.get('who').touched">
          Por favor, especifique o responsável.
        </div>
      </div>

      <div class="form-group">
        <label>Como será feito?</label>
        <textarea class="form-control" formControlName="how" rows="3"></textarea>
        <div class="invalid-feedback" *ngIf="planoAcaoForm.get('how').invalid && planoAcaoForm.get('how').touched">
          Por favor, descreva o processo.
        </div>
      </div>

      <div class="form-group">
        <label>Quanto custará?</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">R$</span>
          </div>
          <input type="number" class="form-control" formControlName="howMuch" step="0.01">
        </div>
        <div class="invalid-feedback" *ngIf="planoAcaoForm.get('howMuch').invalid && planoAcaoForm.get('howMuch').touched">
          Por favor, informe o valor.
        </div>
      </div>

      <div class="form-group">
        <label>Status</label>
        <select class="form-control" formControlName="status">
          <option value="Pendente">Pendente</option>
          <option value="Em Andamento">Em Andamento</option>
          <option value="Concluído">Concluído</option>
        </select>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancelar</button>
    <button type="button" class="btn btn-primary" (click)="salvarPlanoAcao()" [disabled]="!planoAcaoForm.valid">
      {{ planoSelecionado ? 'Atualizar' : 'Salvar' }}
    </button>
  </div>
</ng-template> 